import React, { createContext, useContext } from 'react';

// Determines whether the content-studio is being rendered in a remote/embedded context
// (e.g., embedded in another application like ESS) vs. standalone. Used to conditionally render
// UI elements and apply behaviors appropriate to each context.
interface RemoteAppContextType {
  isRemoteApp: boolean;
}

const RemoteAppContext = createContext<RemoteAppContextType | undefined>(undefined);

export const RemoteAppContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <RemoteAppContext.Provider value={{ isRemoteApp: true }}>{children}</RemoteAppContext.Provider>
);

// Hook to access the RemoteAppContext. Returns { isRemoteApp: false } as a default
// fallback if the hook is called outside the RemoteAppContextProvider, allowing safe
// usage without requiring the provider to be present.
export const useRemoteApp = () => {
  const context = useContext(RemoteAppContext);
  return context ?? { isRemoteApp: false };
};
